
    <fl-navigation-performance-tracking></fl-navigation-performance-tracking>
    <fl-memory-leak-tracking></fl-memory-leak-tracking>
    <fl-synthetic-performance-tracking></fl-synthetic-performance-tracking>
  


// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-i18n-webapp-compat/LANG/sq/webapp/src/app/@shared/tracking/tracking.component.ts.TrackingComponent.html